export default __webpack_public_path__ + "static/media/copy-address.c4b050cd.svg";